module.exports = __webpack_public_path__ + "static/media/view1.416b10e3.jpg";